// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"def4bd7b","254":"ae4e5178","309":"ba1edc58","618":"2a3db3e4","712":"d362eb00","733":"72c895ba","853":"50ad5994"}[chunkId] + ".chunk.js";
};